<template>
  <basic-page :title="pageTitle">
    <v-row>
      <v-col cols="12" md="10" offset-md="1">
        <v-card>
          <v-card-title>
            <v-btn icon @click="cancel" class="mr-2">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            {{ cardTitle }}
          </v-card-title>
          <v-card-text class="pa-0">
            <v-skeleton-loader
              v-if="loading"
              type="article, actions"
            ></v-skeleton-loader>
            <expense-claim-form
              v-else
              ref="claimForm"
              :initial-claim="claim"
              @saved="onSaved"
              @cancel="cancel"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </basic-page>
</template>

<script>
import BasicPage from "@/components/BasicPage";
import ExpenseClaimForm from "@/components/ExpenseClaimForm";
import { firestore as db } from "@/plugins/firebase.app";
import { doc, getDoc } from "firebase/firestore";

export default {
  name: "ExpenseClaimEdit",
  components: { BasicPage, ExpenseClaimForm },
  data() {
    return {
      loading: false,
      claim: null,
    };
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id;
    },
    pageTitle() {
      return this.isEdit ? "Muokkaa kululaskua" : "Uusi kululasku";
    },
    cardTitle() {
      return this.isEdit ? "Muokkaa tietoja" : "Täytä tiedot";
    },
  },
  async created() {
    if (this.isEdit) {
      await this.fetchClaim();
    }
  },
  methods: {
    async fetchClaim() {
      this.loading = true;
      try {
        const docRef = doc(db, "expense_claims", this.$route.params.id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          this.claim = { id: docSnap.id, ...docSnap.data() };
        } else {
          this.$toast.error("Kululaskua ei löytynyt");
          this.$router.push({ name: "Kululaskut" });
        }
      } catch (e) {
        console.error("Error fetching claim", e);
        this.$toast.error("Virhe haettaessa kululaskua");
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.$router.push({ name: "Kululaskut" });
    },
    onSaved() {
      this.$router.push({ name: "Kululaskut" });
    },
  },
};
</script>
